module.exports = __webpack_public_path__ + "static/25-27452e0ec084bb328dc43c29b400e845.jpg";